import Keycloak from 'keycloak-js';

const keycloak = Keycloak({
    url: 'https://login.amuz.gda.pl/auth/',
    realm: 'aMuz',
    clientId: 'dyplomy',
});

export default keycloak;